export const modulesWithCreator = [
    "drivers",
    "locations",
    "branches",
    "suppliers",
    "organizations",
    "trucks",
    "truckTypes",
    "adminUsers",
    "users",
    "tags",
];
